/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon16Solid = forwardRef('ArrowADownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.75 11.107V2.5a1.25 1.25 0 1 1 2.5 0v8.607l2.788-2.787a1.25 1.25 0 0 1 1.768 1.767l-3.928 3.928a2.656 2.656 0 0 1-3.756 0l-3.928-3.928A1.25 1.25 0 0 1 3.962 8.32l2.788 2.787Z" })));
});
